import configLocal from "./env/configLocal";
import configPrd from "./env/configPrd";
import configStg from "./env/configStg";

export interface AppConfig {
  rootPath: string;
  apiGateway: {
    region: string;
    endpoint: string;
  };
  s3: {
    region: string;
    bucket: {
      staticContents: {
        endpoint: string;
      };
    };
  };
  ga4: {
    trackingId: string;
  };
}

let config!: AppConfig;

switch (process.env.REACT_APP_STAGE) {
  case "prd":
    config = configPrd;
    break;
  case "stg":
    config = configStg;
    break;
  case "dev":
    //   config = configDEV;
    break;
  default:
    config = configLocal;
}

export default config;
